<template>
    <div class="festival-wrapper movie-box padding20">
        <div>
            <router-link class="movie-box page-margin-bottom2 page-relative page-block" v-for="(item, ind) in list" :key="ind" :to="{path: item.path}">
                <img class="page-image card" :src="item.src" />
                <div class="page-absolute label">
                    <img class="page-image1" src=https://www.pinuc.com/activity_m/images/online.png />
                </div>
            </router-link>
        </div>
    </div>
</template>

<script>
export default {
    name: "Festival",
    data: function () {
        return {
            list: [
                {
                    path: "/festival/2",// 夏日清凉
                    src: require("@assets/images/summer-card.jpg")
                }, 
                // {
                //     path: "/festival/3",// 100周年
                //     src: require("@assets/images/fap-card.jpg")
                // },
                // {
                //     path: "/festival/1",// 儿童节
                //     src: require("@assets/images/children-card.jpg")
                // },
                {
                    path: "/festival/4",// 妇女节
                    src: require("@assets/images/funv-card.jpg")
                },
            ]
        }
    }
}
</script>

<style scoped>
.card {
    border-radius: .2rem;
}
.label {
    top: 0;
    right: 0;
}
.label img {
    width: 1.2rem;
    border-radius: 0 .18rem 0 0;
}
</style>